import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Skeleton } from '@mui/material';
import PageContainer from '../../components/PageContainer';
import { EmptyState, PageHeader, Panel } from '../../components/ui';
import AuthorsTable from '../../components/AthorsTable';
import { Authors } from '../../store/slices';

const DEFAULT_PAGING_STATE = {
    perPage: 25,
    page: 1,
    total: 0,
};

/** Read-only list of story authors; the story count links to that author's stories. */
const AuthorsPage = () => {
    const { authors, status, queryParams } = useSelector<any, { authors: any[]; status: string; queryParams: any }>((state) => ({
        authors: Object.values(state.authors.data),
        status: state.authors.status,
        queryParams: state.authors.queryParams,
    }));
    const dispatch = useDispatch();

    const loadAuthors = (params: any) => {
        // The thunk's argument is untyped; the cast mirrors the previous ts-ignore.
        dispatch<any>((Authors.getAuthors as any)(params));
    };

    useEffect(() => {
        loadAuthors({
            page: queryParams?.page || DEFAULT_PAGING_STATE.page,
            perPage: queryParams?.perPage || DEFAULT_PAGING_STATE.perPage,
        });
        // Mount-only load, as before; pagination reloads on its own.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loading = status === 'loading';
    const paging = { ...DEFAULT_PAGING_STATE, ...queryParams };

    return (
        <PageContainer constrained>
            <PageHeader eyebrow="Customer Stories" title="Authors" subtitle="Everyone who submitted a story, with their rewards and Shopify customer id." />
            <Panel padding="none">
                {loading && (
                    <div style={{ padding: 16, display: 'grid', gap: 10 }} role="status" aria-label="Loading authors">
                        {[0, 1, 2, 3, 4, 5].map((row) => <Skeleton key={row} animation="wave" height={44} />)}
                    </div>
                )}
                {!loading && authors.length > 0 && <AuthorsTable authors={authors} paging={paging} pagingUpdate={loadAuthors} />}
                {!loading && authors.length === 0 && <EmptyState title="No authors yet" hint="Authors appear here once the first story is submitted." />}
            </Panel>
        </PageContainer>
    );
};

export default AuthorsPage;
